import React from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import Dashboard from "./Dashboard";
import { Grid, styled } from "@mui/material";

const LandingPageWrapper = styled(Grid)`
  background: "#0000FF";
`;

function AdminDashboard() {
  return (
    <LandingPageWrapper>
      <Navbar />
      <Dashboard />
      <Footer />
    </LandingPageWrapper>
  );
}

export default AdminDashboard;
